import { getRequest, postRequest } from "../../utils/apiHelper";
import {
  setAppointmentLoading,
  setCurrentAppointment,
  setAppointmentError,
  setWorkNotes,
  updateAppointmentStatus,
  setError,
  setWorkNotesError,
  setFieldStatus,
  removeFieldStatus,
  setProductsRecords,
} from "./appointmentSlice";

export const GetAppointmentDetailsAPI = (appointmentId) => (dispatch) => {
  try {
    dispatch(setAppointmentLoading(true));
    getRequest(`api/Appointment/GetAppointmentByApptId/${appointmentId}`)
      .then((res) => {
        const appointmentData = res?.data || {};
        dispatch(setCurrentAppointment(appointmentData)); // Save raw data

        // Set notes if present
        if (appointmentData.notes) {
          dispatch(setWorkNotes(appointmentData.notes));
          dispatch(setFieldStatus(appointmentData.fieldStatus));
        }
      })
      .catch((error) => {
        dispatch(
          setAppointmentError(
            error?.response?.data?.message ||
              "Failed to fetch appointment details"
          )
        );
      });
  } catch (e) {
    dispatch(setAppointmentError("Failed to fetch appointment details"));
  }
};

export const updateAppointmentStatusAPI =
  (appointmentId, newStatus) => (dispatch) => {
    return new Promise((resolve, reject) => {
      try {
        // Request URL params include technicianStatusId as you have
        postRequest(
          `api/Appointment/UpdateAppointmentStatus?appointmentId=${appointmentId}&appointmentStatusId=${newStatus}`
        )
          .then((res) => {
            // Update dashboard state
            dispatch(updateAppointmentStatus({ appointmentId, newStatus }));
            // Also update appointment detail if open
            dispatch(
              updateAppointmentStatus({
                appointmentId,
                newStatus,
              })
            );
            resolve(res);
          })
          .catch((e) => {
            const errorMessage = e?.response?.data || e?.message;
            dispatch(setError(errorMessage));
            reject(e);
          });
      } catch (e) {
        dispatch(
          setError(
            "An unexpected error occurred while updating appointment status"
          )
        );
        reject(e);
      }
    });
  };

export const UpdateAppointmentNotesAPI =
  (appointmentId, notes) => (dispatch) => {
    return new Promise((resolve, reject) => {
      try {
        postRequest(
          `api/Appointment/UpdateAppointmentNotes?appointmentId=${appointmentId}&notes=${notes}`
        )
          .then((res) => {
            // dispatch(setWorkNotes(notes));
            resolve(res);
          })
          .catch((e) => {
            const errorMessage = e?.response?.data || e?.message;
            dispatch(setError(errorMessage));
            reject(e);
          });
      } catch (e) {
        dispatch(
          setError(
            "An unexpected error occurred while updating appointment status"
          )
        );
        reject(e);
      }
    });
  };

// Add or update technician time records
export const addOrUpdateTechnicianTimeRecord =
  (appointmentId, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
      try {
        postRequest("api/Appointment/AddFieldTechnicianStatus", payload)
          .then((res) => {
            dispatch(GetAppointmentDetailsAPI(appointmentId));
            resolve(res.data);
          })
          .catch((err) => {
            const message =
              err?.response?.data?.Message ||
              err?.message ||
              "Failed to save time record";
            dispatch(setError(message));
            reject(message);
          });
      } catch (error) {
        dispatch(
          setError("Unexpected error occurred while saving time record")
        );
        reject(error);
      }
    });
  };

export const deleteTechnicianTimeRecordAPI = (id) => (dispatch) => {
  const headers = { CompanyId: "1" };
  return postRequest(
    `api/Appointment/DeleteFieldTechnicianStatus?id=${id}`,
    null,
    headers
  )
    .then((res) => {
      if (res) {
        dispatch(removeFieldStatus(id));
        return true;
      }
      return false;
    })
    .catch(() => false);
};

export const getProductsServicesAPI = (input) => (dispatch) => {
  try {
    postRequest(`api/ProductService/GetProducts`)
      .then((res) => {
        dispatch(setProductsRecords(res?.data));
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
      });
  } catch {}
};

// Add or update technician time records
export const addOrUpdateAppointmentItem =
  (appointmentId, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
      try {
        postRequest("api/Appointment/AddAppointmentItem", payload)
          .then((res) => {
            dispatch(GetAppointmentDetailsAPI(appointmentId));
            resolve(res.data);
          })
          .catch((err) => {
            const message =
              err?.response?.data ||
              err?.message ||
              "Failed to save time record";
            dispatch(setError(message));
            reject(message);
          });
      } catch (error) {
        dispatch(
          setError("Unexpected error occurred while saving time record")
        );
        reject(error);
      }
    });
  };
